// utils/token-estimator.js — T5 前端 token 估算
// 与后端 lib/aichat/token-estimator.mjs 保持一致,用于输入栏 token 计数显示
// 仅作粗略估算,不追求精确

const CJK_RE = /[\u4e00-\u9fff\u3040-\u30ff\uac00-\ud7af]/g;

export function estimateTokens(text) {
  if (!text) return 0;
  const str = typeof text === "string" ? text : String(text);
  const cjk = (str.match(CJK_RE) || []).length;
  const other = str.length - cjk;
  return Math.ceil(cjk / 1.5 + other / 4);
}

export function estimateMessagesTokens(messages) {
  if (!Array.isArray(messages)) return 0;
  return messages.reduce((sum, m) => {
    const contentTokens = estimateTokens(m?.content || "");
    // tool_invocations: 前端消息结构里没有 tool_invocations,但 TOOL_CALL/TOOL_RESULT
    // 消息会带 toolData,粗略计入以反映工具调用对上下文的影响
    let toolTokens = 0;
    const toolData = m?.toolData;
    if (toolData) {
      const argsStr = toolData.args ? JSON.stringify(toolData.args) : "";
      const resultStr = toolData.result ? String(toolData.result) : "";
      toolTokens = estimateTokens(argsStr) + estimateTokens(resultStr);
    }
    const attTokens = Array.isArray(m?.attachments) ? m.attachments.length * 200 : 0;
    return sum + contentTokens + toolTokens + attTokens + 4;
  }, 0);
}
